module.exports = __webpack_public_path__ + "img/Vector.fcdf2725.svg";